export const UPDATE_NB_SLOTS_PASSED = 'UPDATE_NB_SLOTS_PASSED'

export function nbOfSlotsPassedReducer (state = 0, action) {
    switch (action.type){
        case UPDATE_NB_SLOTS_PASSED:
            return action.payload
        default: return state
    }
}